angular
  .module('capability-ng-resources')
  .factory('favoriteResourceCommand', function favoriteResourceCommandDefinition($q, $http, defineCommand) {
    return defineCommand('favoriteResourceCommand', function favoriteResourceCommand(deferred, resource) {
      $http
        .post('favorite/favoriteitem/', {
          content_type: 'inst.resource',
          object_id: resource.id,
          cache: false
        })
        .then(function (response) {
          const updatedResource = { id: resource.id, favorite_id: response.data.id, is_favorite: true };
          deferred.resolve(updatedResource);
        })
        .catch(function (err) {
          deferred.reject(err);
        });
    });
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/commands/favorite_resource_command.es.js